<template>
    <div>
      <div class="banner">
          <img src="../../assets/goyb.jpg" alt="">
      </div>
      <h2 class="title">翼博餐饮集成信息化系统盛大上线</h2>
    <hr>
    <div class="main">
        <div class="content">
            <p>在这个数字化飞速发展的时代，翼博餐饮也在数字化管理领域迎来了新的变革。今日，经过长时间的精心研发与测试，我司自主研发的“翼博餐饮集成信息化系统”正式全面上线，标志着翼博餐饮在数字化管理领域向更加高效、智能、精细化的方向迈出了坚实的一步。</p>
            <div class="new_img1"><img src="../../assets/goyb/new-l.png" alt=""></div>
            <p class="a1">技术革新，重塑管理生态</p>
            <p>“翼博餐饮集成信息化系统”作为我司技术实力的集中展现，打破了原有管理中信息系统分散、数据孤岛的现状。该系统通过强大的集成能力，将原本各自为政的物料管理、成本管理、收入统计、服务监控等多个系统无缝融合，实现了资源的高度共享与跨项目的实时信息统计分析。这一创新不仅极大地提升了数据处理效率，更为企业决策提供了全面、准确的数据支持。</p>
            <p class="a1">灵活定制，满足个性化需求</p>
            <p>深知不同客户对于食堂管理的差异化需求，我们特别设计了高度灵活的定制化功能。在“翼博餐饮集成信息化系统”中，不但可以快速建立新项目，并可以根据各个项目的业务特点和管理需求，自定义收入、成本、物料消耗、服务人次等多维度的统计分析报表。更重要的是，系统支持根据客户的特殊需要和关注点，量身定制专用的统计分析指标，确保每一位客户都能享受到量身定制的精细化管理解决方案，全面满足食堂管理的精细化要求及审计标准。</p>
            <p class="a1">精细化管理，驱动效率提升</p>
            <p>“翼博餐饮集成信息化系统”的上线，不仅是对传统餐饮管理模式的一次重大升级，更是我们积极响应市场需求，推动行业进步的重要举措。通过系统的深度应用，客户将能够实现对食堂运营的全方位、精细化监控，从而有效提升管理效率，降低成本支出，增强服务品质，最终实现经济效益与社会效益的双赢。</p>
            <p class="a1">展望未来，共创辉煌</p>
            <p>我们坚信，“翼博餐饮集成信息化系统”的推出，将大大提高翼博餐饮所属项目的管理效率，为客户带来更加高效、透明的信息环境，也为广大餐饮企业提供了一种新的管理模式和管理工具。未来，我们将继续秉承创新、务实、高效的理念，不断优化产品功能，提升服务质量，与广大客户携手共进，共同开创餐饮管理的新篇章。</p>
        </div>
        <hr>
        <div class="new_next">
        <router-link to="/honor/new6">
            <div class="new_right">上一篇:郑州翼博餐饮携手海为酒店，首次婚宴合作美食盛宴引赞叹</div>
        </router-link>
        <router-link to="/honor/new3">
            <div class="new_right">下一篇:翼博餐饮成功中标郑州海为酒店餐厅服务商，携手共创餐饮新篇章</div>
        </router-link>
        </div>
    </div>
    </div>
  </template>
  
  <script>
export default {
    mounted () 
 {
    this.$router.afterEach((to, from, next) => {
        window.scrollTo(0, 0)
    })
}

}
  </script>
  
  <style scoped>
  .banner{
      width: 100%;
      height: 3rem;
      overflow: hidden;
  }
  .banner:hover img{
      transform: scale(1.2);
  }
  .banner img{
      transition: all .4s;
      width: 100%;
      height: 100%;
      display: block;
      object-fit: cover;
  }
  .yy-box1{
    margin: 0;
    padding-top: 20px;
    padding-bottom: 20px;
    background-color: #f6f6f6;
}
  
  /* 标题 */
.title{
    margin: .2rem 0;
    font-size: .13rem;
}
hr{
    width: 60%;
    margin: 0 auto;
}
.main{
    width: 60%;
    /* background-color: pink; */
    margin: .1rem auto;
}
.content p{
    text-indent:2em;
    text-align: left;
    font-size: .1rem;
    line-height: .23rem;
}
.content .a1{
    text-align: center;
    font-weight: 700;
}
.new_img1{
    width: 800px;
    height: 400px;
    margin: 5px auto;
}
.new_img1 img{
    width: 100%;
    height: 100%;
}
/* 翻篇 */
.new_next{
    width: 100%;
    /* height: 2rem; */
    /* margin-top: .2rem; */
    /* background-color: pink; */
    font-size: .09rem;
    text-align: left;
}
/* .new_next .new_left, */
.new_next .new_right{
    padding:.09rem 0;
}
.new_next .new_right:hover{
    color: red;
}
.main hr{
    width: 100%;
    margin-top: .2rem;
}
  </style>